import * as actionTypes from "./cityesActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
const { REACT_APP_API_URL } = process.env;

export const getCity = (data) => {
    // const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('customerToken')}` }, params: data }
    return (dispatch) => {
        dispatch(getCityInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/city/consumer`, data))
            .then((response) => {
                dispatch(getCitySuccess(response.data.data));
            }).catch((error) => {
                dispatch(getCityFail());
                checkError(error);
            })
    }
}
const getCityInit = () => ({
    type: actionTypes.GET_CITY,
})
const getCitySuccess = (data) => ({
    type: actionTypes.GET_CITY_SUCCESS,
    payload: { data }
})
const getCityFail = () => ({
    type: actionTypes.GET_CITY_FAILURE,
})